import {
	Box,
	FormControl,
	Typography,
	InputLabel,
	Select,
	MenuItem,
	TextField,
	Grid,
	InputAdornment,
	Chip,
	Checkbox,
	FormControlLabel,
} from "@mui/material";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import EditIcon from "@mui/icons-material/Edit";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import React, { useEffect } from "react";
import { sizes } from "../scenarioSetupNewUtils";
import { useDispatch, useSelector } from "react-redux";
import {
	getDataSources,
	setState,
	getCustGrpRef,
	reset,
  getCustomerCountries,
} from "../scenarioSetupNewSlice";
import { width } from "@mui/system";

const commonHeight = sizes.h35;

export default function ScenarioInfoForm() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.scenarioSetupNew);
	const loginState = useSelector((store) => store.login);
	const {
		countries,
		selectedCountry,
		scenarioName,
		periodType,
		periodTypes,
		createFromDate,
		createToDate,
		sentToSAP,
		countryID,
		predictionMethodPeriodList,
		previousYearPeriodList,
		DefaultInitialForecast,
	} = setupState;
	const { globalSelectedCountryName, globalSelectedCountryID } = loginState;
	const minSelectableDate = new Date();
	//const minSelectableDate = dayjs().startOf("month").toDate();
	const y = minSelectableDate.getFullYear();
	const m =
		minSelectableDate.getMonth() + 1 < 10
			? `0${minSelectableDate.getMonth() + 1}`
			: minSelectableDate.getMonth() + 1;
	const d = "01";
	const minDate = `${y}-${m}-${d}`;

	useEffect(() => {
		if (globalSelectedCountryID !== null) {
			if (countryID !== globalSelectedCountryID) {
				dispatch(reset("searchInfo"));
			}
			dispatch(setState("countryID", globalSelectedCountryID));
		}
	}, [globalSelectedCountryID]);

	useEffect(() => {
		if (
			globalSelectedCountryName !== null &&
			globalSelectedCountryName !== ""
		) {
			dispatch(setState("selectedCountry", globalSelectedCountryName));
		}
	}, [globalSelectedCountryName]);

	const handleCountryChange = (event) => {
		dispatch(reset("searchInfo"));
		const countryName = event.target.value;
		const countryId = countries.find(
			(country) => country.countryName === countryName
		).countryID;
		dispatch(setState("selectedCountry", countryName));
		dispatch(setState("countryID", countryId));

		clearCountryDependents();
		getCountryDependents(countryId);
	};

	const clearCountryDependents = () => {
		dispatch(setState("dataSources", []));
		dispatch(setState("selectedDSs", []));
		dispatch(setState("customerCountries", []));
		dispatch(setState("selCustCountries", []));
	};

	const getCountryDependents = (countryID) => {
		dispatch(getDataSources({ countryID }));
		dispatch(getCustGrpRef({ countryID })).then((res) => {
			let { customerLevels, customerTypes } = res.payload;
			let firstType = null,
				level = null;
			if (customerTypes && customerTypes.length > 0) {
				firstType = customerTypes[0];
			}
			if (customerLevels && customerLevels.length > 0) {
				level = customerLevels.find(
					(custLevel) => custLevel.customerLevelID === "SH"
				);
			}
			dispatch(
				getCustomerCountries({
					CountryId: countryID,
					Level: level.customerLevelID,
					Type: "All",
				})
			);
		});
	};

	const validFromDate = (date) => {
		if (periodType.length <= 0) {
			showMessage("Please select period type first", "info");
			return false;
		}
		if (periodType === "Weekly" && date.day() !== 1) {
			showMessage("Chosen day must be Monday for weekly period type", "info");
			return false;
		}
		if (periodType === "Monthly" && date.date() !== 1) {
			showMessage(
				"Chosen day must be first day of month for monthly period type",
				"info"
			);
			return false;
		}
		if (date < dayjs() && periodType === "Weekly" && date.day() !== 1) {
			showMessage("Past dates cannot be selected", "info");
			return false;
		}
		if (date < dayjs() && periodType === "Monthly" && date.date() !== 1) {
			showMessage("Past dates cannot be selected", "info");
			return false;
		}
		if (date > createToDate) {
			showMessage("Invalid from date", "info");
			return false;
		}
		return true;
	};

	const validToDate = (date) => {
		if (periodType.length <= 0) {
			showMessage("Please select period type first", "info");
			return false;
		}
		if (periodType === "Weekly" && date.day() !== 0) {
			showMessage("Chosen day must be Sunday for weekly period type", "info");
			return false;
		}
		if (periodType === "Monthly" && !date.isSame(date.endOf("month"), "day")) {
			showMessage(
				"Chosen day must be last day of month for monthly period type",
				"info"
			);
			return false;
		}
		if (date < dayjs()) {
			showMessage("Past dates cannot be selected", "info");
			return false;
		}
		if (date < createFromDate) {
			showMessage("Invalid from date", "info");
			return false;
		}
		return true;
	};

	const handleCreateFromDate = (newDate) => {
		validFromDate(newDate);
		dispatch(setState("createFromDate", newDate));
	};

	const handleCreateToDate = (newDate) => {
		validToDate(newDate);
		dispatch(setState("createToDate", newDate));
	};

	const handleScenarioName = (event) => {
		let name = event.target.value;
	  
		// Remove special characters
		name = name.replace(/[^a-zA-Z0-9 ]/g, "");
	  
		//Replace multiple consecutive spaces with a single space
		name = name.replace(/\s{2,}/g, " ");
	  
		// Trim leading space
		name = name.trimStart();
	  
		//Country selection check
		if (selectedCountry.length <= 0) {
		  showMessage("Please select a country first", "info");
		  return;
		}
	  
		//Dispatch cleaned value
		dispatch(setState("scenarioName", name));
	  };
	  

	// const handleScenarioName = (event) => {
	// 	let name = event.target.value;
	  
	// 	// 1. Remove all special characters (except space)
	// 	name = name.replace(/[^a-zA-Z0-9 ]/g, "");
	  
	// 	// 2. Check for multiple consecutive spaces
	// 	if (/\s{2,}/.test(name)) {
	// 	  showMessage("Multiple consecutive spaces are not allowed", "warning");
	// 	  return;
	// 	}
	  
	// 	// 3. Trim leading space (optional — allow trailing for smoother typing)
	// 	name = name.trimStart();
	  
	// 	// 4. Proceed only if a country is selected
	// 	if (selectedCountry.length <= 0) {
	// 	  showMessage("Please select a country first", "info");
	// 	  return;
	// 	}
	  
	// 	// 5. Dispatch cleaned value
	// 	dispatch(setState("scenarioName", name));
	//   };
	  

	// const handleScenarioName = (event) => {
	// 	const pattern = /^[a-zA-Z0-9 ]*$/;
	// 	let name = event.target.value;

	// 	if(name.includes("  ")){
	// 		return;
	// 	}

	// 	if (event.target.value == " ") {
	// 		event.target.value = event.target.value.replace(" ", "");
	// 	} else if (event.target.value.startsWith(" ")) {
	// 		event.target.value = event.target.value.trimStart();
	// 	}
	// 	if (!pattern.test(event.target.value)) {
	// 		event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, "");
	// 	}
	// 	if (selectedCountry.length <= 0) {
	// 		showMessage("Please select a country first", "info");
	// 		return;
	// 	}
	// 	const value = event.target.value;
	// 	dispatch(setState("scenarioName", value));
	// };

	const handlePeriodType = (event) => {
		if (scenarioName.length <= 0) {
			showMessage("Please enter scenario name first", "info");
			return;
		}
		const value = event.target.value;
		dispatch(setState("periodType", value));
		if (value === "Weekly") {
			dispatch(setState("createToDate", dayjs("2099-12-27")));
		} else {
			dispatch(setState("createToDate", dayjs("2099-12-31")));
		}
	};

	const handleCheckedUpdate = (event, stateName) => {
		const option = event.target.checked;
		dispatch(setState(stateName, option));
	};

	const showMessage = (message, severity) => {
		dispatch(setState("message", message));
		dispatch(setState("severity", severity));
		dispatch(setState("messageOpen", true));
	};

	return (
		<Box sx={{ mt: 4 }}>
			<Grid
				container
				columns={12}
				columnSpacing={3}
				rowSpacing={3}
				justifyContent={"space-between"}
			>
				<Grid item md={2} xs={12}>
					<Box sx={{ mt: 0 }}>
						<FormControl sx={{ width: "100%" }}>
							<InputLabel id="demo-simple-select-label">Country</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={selectedCountry}
								label="Country"
								sx={{
									height: commonHeight,
									width: sizes.w300,
									color: "black.main.main",
									mt: 1,
								}}
								onChange={handleCountryChange}
							>
								{countries.map((country, index) => {
									return (
										<MenuItem value={country.countryName} key={index}>
											{country.countryName}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Box>
				</Grid>
				<Grid item sm={2.5} xs={12}>
					<Box>
						<TextField
							sx={{ width: "100%" }}
							id="input-with-icon-textfield"
							label="Scenario Name"
							placeholder="Country code Brand Strength Packsize"
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<EditIcon />
									</InputAdornment>
								),
								autoComplete: "off",
							}}
							variant="standard"
							// sx={{
							// 	width: sizes.w300,
							// }}
							value={scenarioName}
							onChange={handleScenarioName}
						/>
					</Box>
				</Grid>

				<Grid md={2} item xs={12}>
					<Box>
						<FormControl sx={{ width: "100%" }}>
							<InputLabel id="demo-simple-select-label">Period Type</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={periodType}
								label="Period Type"
								sx={{
									height: commonHeight,
									width: sizes.w300,
									color: "black.main.main.main",
									mt: 1,
								}}
								onChange={handlePeriodType}
							>
								{periodTypes.map((type, index) => {
									return (
										<MenuItem value={type.name} key={index}>
											{type.name}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Box>
				</Grid>

				<Grid md={2} item xs={12}>
					<Box>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DatePicker
								sx={{ width: "100%" }}
								// minDate={minSelectableDate}
								minDate={dayjs(minDate)}
								label="From"
								value={createFromDate}
								onChange={(newValue) => handleCreateFromDate(newValue)}
								renderInput={(params) => <TextField {...params} size="small" />}
								format="DD/MM/YYYY"
							/>
						</LocalizationProvider>
					</Box>
				</Grid>
				<Grid item md={2} xs={12}>
					<Box>
						<LocalizationProvider dateAdapter={AdapterDayjs}>
							<DatePicker
								sx={{ width: "100%" }}
								// minDate={minSelectableDate}
								minDate={dayjs(minDate)}
								label="To"
								value={createToDate}
								onChange={(newValue) => handleCreateToDate(newValue)}
								renderInput={(params) => <TextField {...params} size="small" />}
								format="DD/MM/YYYY"
							/>
						</LocalizationProvider>
					</Box>
				</Grid>

				<Grid item md={1.5} xs={12}>
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
						}}
					>
						<FormControlLabel
							control={
								<Checkbox
									checked={sentToSAP}
									onChange={(event) => handleCheckedUpdate(event, "sentToSAP")}
									InputProps={{ "aria-label": "controlled" }}
									sx={{ ml: 1 }}
								/>
							}
						/>

						<Typography
							variant="subtitle2"
							sx={{ mt: 1.5, fontSize: 14, ml: -2 }}
						>
							Send to SAP
						</Typography>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}
